import styled, { css } from "styled-components"

import { SpacingSize, Color, IsPC, IsMobile, LineHeight, TextSize, RadiusSize, Shadow } from "~/consts/style-mixins"

export const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 92px - 176px);
  ${IsMobile(css`
    background-image: none;
  `)}
  // 汎用スタイル
  .pcnone {
    display: none;
    ${IsMobile(css`
      display: block;
    `)}
  }
  .spnone {
    display: block;
    ${IsMobile(css`
      display: none;
    `)}
  }
  // フローティングボタン
  .floating-btn-wrap {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    ${Shadow.Deep};
    position: fixed;
    bottom: 0;
    padding: 5px 0 10px;
    z-index: 1;
    transition: 300ms opacity ease-in-out;
  }
  .floating-btn {
    display: block;
    width: 450px;
    height: 50px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    text-align: center;
    letter-spacing: 0.1em;
    color: ${Color.White};
    background-color: ${Color.Attention};
    padding: 5px 0 4px;
    border-radius: 25px;
    box-shadow: 0px 4px 0px 0px ${Color.AttentionDark};
    ${IsMobile(css`
      width: 90%;
      max-width: 450px;
      min-width: 320px;
    `)}
    span {
      font-size: 10px;
      line-height: ${LineHeight.S}%;
      display: block;
    }
    :hover {
      box-shadow: none;
      transform: translateY(3px);
    }
  }
  // KV
  .kv-wrap {
    position: relative;
    width: 100%;
    background-image: url("/next/static/images/lti-registration-lp/bg_kv_pc.png");
    background-size: cover;
    background-position: center;
    text-align: center;
    color: ${Color.White};
    font-weight: bold;
    ${IsMobile(css`
      min-height: 490px;
      background-image: url("/next/static/images/lti-registration-lp/bg_kv_sp.png");
    `)}
  }
  .kv-logo {
    text-align: left;
    img {
      margin: 16px 0 12px 20px;
      width: 180px;
      ${IsMobile(css`
        margin: 12px 0 44px 20px;
        width: 167px;
      `)}
    }
  }
  .kv-txt-main {
    font-size: 46px;
    line-height: ${LineHeight.S}%;
    margin-bottom: 8px;
    ${IsMobile(css`
      font-size: 7.5vw;
      margin-bottom: 12px;
    `)}
  }
  .kv-emblem {
    width: 463px;
    margin: 0 auto 10px;
    ${IsMobile(css`
      width: 90%;
      max-width: 420px;
    `)}
  }
  .kv-txt-read {
    font-size: 14px;
    line-height: ${LineHeight.L}%;
    margin-bottom: 21px;
    ${IsMobile(css`
      font-size: 3.1vw;
      margin-bottom: 22px;
    `)}
  }
  .kv-companies {
    display: flex;
    align-items: center;
    width: calc(100% - 32px);
    max-width: 720px;
    height: 32px;
    font-size: 13px;
    font-family: "Hiragino Kaku Gothic ProN";
    font-weight: 600;
    line-height: 160%;
    color: ${Color.White};
    background: rgba(122, 190, 255, 0.25);
    border-radius: 30px;
    margin: 0 auto 20px;
    ${IsMobile(css`
      font-size: 12px;
      height: 26px;
    `)}

    .kv-txt-ttl {
      align-items: center;
      flex-shrink: 0;
      height: 100%;
      letter-spacing: 0.1em;
      padding: 0 8px 0 18px;
      border-right: 1px solid rgba(255, 255, 255, 0.4);
      line-height: 2.4;
      ${IsMobile(css`
        line-height: 1.8;
      `)}
      sup {
        vertical-align: super;
        font-size: xx-small;
      }
    }

    .kv-wrap-companies {
      display: flex;
      flex: 1;
      margin: 0 12px 0 10px;
      overflow: hidden;
    }

    .kv-txt-companies {
      letter-spacing: 0.1em;
      white-space: nowrap;
      animation: scrollAnime 45s linear infinite;
    }
  }
  @keyframes scrollAnime {
    0% {
      transform: translate3d(0%, 0, 0);
    }
    100% {
      transform: translate3d(-50%, 0, 0);
    }
  }
  .kv-txt-btn-shoulder {
    width: 126px;
    margin: 0 auto;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: ${LineHeight.M}%;
    letter-spacing: 0.1em;
    padding-bottom: 12px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPwAAAAOCAYAAAAL8XF1AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACxSURBVHgB7dpNDcJAFEXhOyiohEpAAhJwAA6QQFEADkBSHVQCEspt8homrEhY8eZ8ycsYmLOYHwlAM8psQgsupZRBP/BWOXm5CX9rI+ALjv0sYgfyW2Kf3wYByMmBX6vYjwKQj+PuPPcI/enZCUA+EfsYsU+erQDk47j7iHyNvReAfIgdaMRH7COxA0ktZ/S4mFtj7wQgH8e9r2J/CEBODvxQvbHziw7IKp7eJn7PteUF1HrCSkFKC5sAAAAASUVORK5CYII=");
    background-size: 126px;
    background-repeat: no-repeat;
    background-position: bottom;
    ${IsMobile(css`
      margin-bottom: 8px;
    `)}
  }
  .kv-cv-btn {
    display: block;
    width: 300px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.1em;
    color: ${Color.White};
    background-color: ${Color.Attention};
    padding: 14px 0;
    border-radius: 24px;
    box-shadow: 0px 4px 0px 0px ${Color.AttentionDark};
    :hover {
      box-shadow: none;
      transform: translateY(3px);
    }
  }
  .kv-caution {
    display: flex;
    justify-content: flex-end;
    text-align: left;
    font-size: 10px;
    line-height: ${LineHeight.XS}%;
    color: ${Color.White};
    opacity: 0.6;
    margin: 42px 8px 0;
    padding-bottom: 8px;
    ${IsMobile(css`
      justify-content: flex-start;
      margin: 32px 8px 0;
    `)}
  }
  // Match あなたに合う求人がきっと見つかる。
  .match-wrap {
    background-image: url("/next/static/images/lti-registration-lp/bg_match.png");
    background-size: 646px;
    background-repeat: no-repeat;
    background-position: top right;
    ${IsMobile(css`
      background-image: none;
    `)}
  }
  .match-inner {
    max-width: 1032px;
    margin: 0 auto;
    padding: 62px 16px 90px;
    ${IsMobile(css`
      padding: 32px 16px 22px;
    `)}
  }
  .match-ttl-shoulder {
    font-size: 16px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    margin-bottom: 4px;
    ${IsMobile(css`
      font-size: 18px;
      text-align: center;
    `)}
    strong {
      color: ${Color.Attention};
      font-size: 24px;
    }
  }
  .match-txt-ttl {
    font-size: 42px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    margin-bottom: 35px;
    ${IsMobile(css`
      font-size: 30px;
      text-align: center;
      text-indent: -0.5em;
      margin-left: 0.5em;
      margin-bottom: 32px;
    `)}
  }
  .match-cnt-wrap-type01 {
    padding: 32px 0 40px;
    background-image: url("/next/static/images/lti-registration-lp/img01_pc.png");
    background-size: 464px;
    background-repeat: no-repeat;
    background-position: top right;
    margin-bottom: 42px;
    ${IsMobile(css`
      padding: 0 0 337px;
      background-image: url("/next/static/images/lti-registration-lp/img01_sp.png");
      background-size: 309px;
      background-repeat: no-repeat;
      background-position: bottom center;
      margin-bottom: 48px;
    `)}
  }
  .match-cnt-wrap-type02 {
    padding: 0 0 20px;
    background-image: url("/next/static/images/lti-registration-lp/img02.png");
    background-size: 446px;
    background-repeat: no-repeat;
    background-position: top right 10px;
    ${IsMobile(css`
      padding: 0 0 123px;
      background-size: 343px;
      background-repeat: no-repeat;
      background-position: bottom center;
      margin-bottom: 42px;
    `)}
  }
  .match-txt-sub-ttl {
    font-size: 18px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    margin-bottom: 8px;
  }
  .match-txt-sub-read {
    width: calc(100% - 56px - 464px);
    line-height: ${LineHeight.L}%;
    ${IsMobile(css`
      width: 100%;
      margin-bottom: 32px;
    `)}
    strong {
      color: ${Color.Primary};
      font-weight: bold;
    }
  }
  // Why なぜ、Infraインターンが選ばれるのか。
  .why-wrap {
    width: 100%;
    background-image: url("/next/static/images/lti-registration-lp/bg_green_pc.png");
    background-size: cover;
    background-position: center;
    color: ${Color.White};
    ${IsMobile(css`
      background-image: url("/next/static/images/lti-registration-lp/bg_green_sp.png");
    `)}
  }
  .why-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 16px 80px;
    ${IsMobile(css`
      padding: 42px 16px 32px;
    `)}
  }
  .why-ttl-catch {
    font-size: 16px;
    text-align: center;
    margin-bottom: 16px;
    .copy {
      display: inline-block;
      font-weight: bold;
      border-bottom: 1px solid ${Color.White};
      padding-bottom: 6px;
    }
  }
  .why-ttl {
    font-size: 32px;
    line-height: ${LineHeight.S}%;
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    ${IsMobile(css`
      font-size: 26px;
    `)}
  }
  .why-cnt-wrap {
    display: flex;
    margin: 0 29px;
    ${IsMobile(css`
      display: inherit;
      margin: 0;
    `)}
  }
  .why-cnt-type01 {
    width: 340px;
    margin-right: 45px;
    background-image: url("/next/static/images/lti-registration-lp/why01.png");
    background-size: 262px;
    background-repeat: no-repeat;
    background-position: top center;
    ${IsMobile(css`
      width: 100%;
    `)}
  }
  .why-cnt-type02 {
    width: 340px;
    margin-right: 45px;
    background-image: url("/next/static/images/lti-registration-lp/why02.png");
    background-size: 262px;
    background-repeat: no-repeat;
    background-position: top center;
    ${IsMobile(css`
      width: 100%;
    `)}
  }
  .why-cnt-type03 {
    width: 340px;
    background-image: url("/next/static/images/lti-registration-lp/why03.png");
    background-size: 262px;
    background-repeat: no-repeat;
    background-position: top center;
    ${IsMobile(css`
      width: 100%;
    `)}
  }
  .why-cnt-ttl {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 10px;
    font-size: 28px;
    line-height: ${LineHeight.S}%;
    text-align: center;
    font-weight: bold;
    height: 240px;
    strong {
      color: #f3ff64;
      line-height: ${LineHeight.S}%;
    }
  }
  .why-cnt-read {
    font-size: 16px;
    line-height: ${LineHeight.M}%;
    margin-top: 16px;
    ${IsMobile(css`
      margin: 22px 0 40px;
    `)}
  }
  // VOICE
  .voice-wrap {
    background-color: #f9f6f2;
  }
  .voice-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 16px 88px;
    ${IsMobile(css`
      padding-bottom: 24px;
    `)}
  }
  .voice-ttl-catch {
    font-size: 16px;
    text-align: center;
    margin-bottom: 16px;
    .copy {
      display: inline-block;
      font-weight: bold;
      border-bottom: 1px solid ${Color.Black};
      padding-bottom: 6px;
    }
  }
  .voice-ttl {
    font-size: 32px;
    line-height: ${LineHeight.S}%;
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    ${IsMobile(css`
      font-size: 26px;
    `)}
    span {
      color: ${Color.Primary};
    }
  }
  .voice-cnt-wrap {
    display: flex;
    ${IsMobile(css`
      display: inherit;
    `)}
  }
  .voice-cnt {
    width: calc((100% - 32px) * 3);
    margin-right: 16px;
    background-color: ${Color.White};
    ${Shadow.Shallow};
    &:last-child {
      margin-right: 0;
    }
    ${IsMobile(css`
      width: 100%;
      margin: 0 0 16px 0;
    `)}
  }
  .voice-account-wrap {
    display: flex;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid ${Color.BorderGray};
    ${IsMobile(css`
      padding: 16px;
    `)}
    img {
      width: 50px;
      margin-right: 16px;
    }
  }
  .voice-account-detail {
    font-size: 12px;
    line-height: ${LineHeight.S}%;
  }
  .voice-university {
    margin-bottom: 2px;
  }
  .voice-occupation {
    font-weight: bold;
  }
  .voice-comment-wrap {
    padding: 24px 24px 32px;
    ${IsMobile(css`
      padding: 16px 16px 24px;
    `)}
  }
  .voice-comment-ttl {
    font-size: 18px;
    font-weight: bold;
    line-height: ${LineHeight.M}%;
    margin-bottom: 12px;
    strong {
      color: ${Color.Primary};
    }
  }
  .voice-comment {
    font-size: 14px;
    line-height: ${LineHeight.M}%;
    strong {
      color: ${Color.Attention};
      font-weight: bold;
    }
  }
  // Support サポート
  .support-wrap {
    width: 100%;
    background-image: url("/next/static/images/lti-registration-lp/bg_blue_pc.png");
    background-size: cover;
    background-position: center;
    ${IsMobile(css`
      background-image: url("/next/static/images/lti-registration-lp/bg_blue_sp.png");
    `)}
  }
  .support-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 48px 16px 80px;
    ${IsMobile(css`
      padding: 42px 16px 62px;
    `)}
  }
  .support-ttl-catch {
    font-size: 16px;
    color: ${Color.White};
    text-align: center;
    margin-bottom: 16px;
    .copy {
      display: inline-block;
      font-weight: bold;
      border-bottom: 1px solid ${Color.White};
      padding-bottom: 6px;
    }
  }
  .support-ttl {
    font-size: 32px;
    line-height: ${LineHeight.S}%;
    color: ${Color.White};
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    ${IsMobile(css`
      font-size: 26px;
    `)}
  }
  .support-cnt-wrap {
    display: flex;
    ${IsMobile(css`
      display: inherit;
    `)}
  }
  .support-cnt {
    position: relative;
    width: calc((100% - 132px) / 3);
    margin-right: 66px;
    background-color: ${Color.White};
    text-align: center;
    padding: 24px;
    &:last-child {
      margin-right: 0;
      ::after {
        display: none;
      }
    }
    ${IsMobile(css`
      width: 100%;
      margin: 0 0 62px 0;
      &:last-child {
        margin-bottom: 0;
      }
    `)}
    ::after {
      content: "";
      display: inline-block;
      position: absolute;
      right: -55px;
      top: 50%;
      width: 40px; /*画像の幅*/
      height: 12px; /*画像の高さ*/
      background-image: url(/next/static/images/lti-registration-lp/arrow.png);
      background-size: contain;
      ${IsMobile(css`
        transform: rotate(90deg);
        top: calc(100% + 23px);
        right: calc(50% - 20px);
      `)}
    }
  }
  .support-cnt-ttl-catch {
    font-size: 12px;
    color: ${Color.Primary};
    font-weight: bold;
  }
  .support-cnt-ttl-number {
    font-size: 28px;
    line-height: ${LineHeight.S}%;
    color: ${Color.Primary};
    font-weight: bold;
  }
  .support-cnt-ttl {
    font-size: 28px;
    line-height: ${LineHeight.S}%;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .support-cnt-detail {
    font-size: 14px;
    line-height: ${LineHeight.S}%;
    text-align: left;
    strong {
      color: ${Color.Attention};
      font-weight: bold;
    }
  }
  // FAQ
  .faq-wrap {
    max-width: 800px;
    margin: 0 auto;
    padding: 48px 16px 88px;
    ${IsMobile(css`
      padding-bottom: 64px;
    `)}
  }
  .faq-ttl-catch {
    font-size: 16px;
    text-align: center;
    margin-bottom: 16px;
    .copy {
      display: inline-block;
      font-weight: bold;
      border-bottom: 1px solid ${Color.Black};
      padding-bottom: 6px;
    }
  }
  .faq-ttl {
    font-size: 32px;
    line-height: ${LineHeight.S}%;
    font-weight: bold;
    text-align: center;
    margin-bottom: 40px;
    ${IsMobile(css`
      font-size: 26px;
    `)}
    span {
      color: ${Color.Primary};
    }
  }
  .faq-question {
    font-size: 18px;
    font-weight: bold;
    line-height: ${LineHeight.M}%;
    margin-bottom: 24px;
    ${IsMobile(css`
      font-size: 16px;
      margin-bottom: 16px;
      text-indent: -1.8em;
      padding-left: 28px;
    `)}
    span {
      font-size: 22px;
      color: ${Color.Primary};
      margin-right: 8px;
    }
  }
  .faq-answer {
    font-size: 14px;
    line-height: ${LineHeight.L}%;
    margin-bottom: 48px;
    ${IsMobile(css`
      margin-bottom: 32px;
    `)}
  }
  // Closing 今から始めよう。
  .closing-wrap {
    max-width: 1000px;
    margin: 0 auto;
  }
  .closing-message {
    font-size: 40px;
    font-weight: bold;
    line-height: ${LineHeight.S}%;
    padding-left: 40px;
    ${IsMobile(css`
      font-size: 32px;
      padding-left: 32px;
    `)}
  }
  // 下部画像用スタイル
  .faq-closing-wrap {
    width: 100%;
    background: url("/next/static/images/lti-registration-lp/bg_bottom_txt_pc.png") right bottom / 136px no-repeat,
      url("/next/static/images/lti-registration-lp/bg_bottom_img_pc.png") center bottom 80px / 1393px no-repeat;
    padding-bottom: 530px;
    ${IsMobile(css`
      background: url("/next/static/images/lti-registration-lp/bg_bottom_txt_sp.png") left bottom / 62px no-repeat,
        url("/next/static/images/lti-registration-lp/bg_bottom_img_sp.png") center bottom 44px / 534px no-repeat;
      padding-bottom: 450px;
    `)}
  }
`
